import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { User } from '../../model/User.model';
import { Company } from '../../model/Company.model';
import { UserService } from '../../service/user.service';
import { CompanyService } from '../../service/company.service';
import { UtilService } from '../../service/util.service';

@Component({
  selector: 'app-cadastro-usuario',
  templateUrl: './cadastro-usuario.component.html',
  styleUrls: ['./cadastro-usuario.component.scss']
})
export class CadastroUsuarioComponent implements OnInit {
  user: User = new User();
  users: User[] = [];
  companies: Company[] = [];
  isEditing: boolean = false;

  constructor(
    private userService: UserService,
    private companyService: CompanyService,
    private router: Router,
    private util: UtilService
  ) { }

  ngOnInit() {    
    this.loadUsers();
    this.loadCompanies();
  }

  loadCompanies() {
    this.companyService.getCompanies().subscribe(
      (companies) => {
        this.companies = companies;
      },
      (error) => {
        this.util.toasterShowError("Atenção", "Erro ao carregar empresas");
      }
    );
  }

  loadUsers() {
    this.userService.getUsers().subscribe(
      (users) => {
        this.users = users;
      },
      (error) => {
        this.util.toasterShowError("Atenção", "Erro ao carregar usuários");
      }
    );
  }

  saveUser() {
    if (!this.validateForm()) {
      return;
    }

    if (this.isEditing) {
      this.userService.updateUser(this.user.guid_usuario, this.user).subscribe(
        () => {
          this.util.toasterShowSuccess("Sucesso", "Usuário atualizado com sucesso");
          this.resetForm();
          this.loadUsers();
        },
        (error) => {
          this.util.toasterShowError("Atenção", "Erro ao atualizar usuário");
        }
      );
    } else {
      this.userService.createUser(this.user).subscribe(
        () => {
          this.util.toasterShowSuccess("Sucesso", "Usuário criado com sucesso");
          this.resetForm();
          this.loadUsers();
        },
        (error) => {
          this.util.toasterShowError("Atenção", "Erro ao criar usuário");
        }
      );
    }
  }

  editUser(user: User) {
    this.user = { ...user };
    this.isEditing = true;
  }

  deleteUser(id: string) {
    if (confirm('Tem certeza que deseja excluir este usuário?')) {
      this.userService.deleteUser(id).subscribe(
        () => {
          this.util.toasterShowSuccess("Sucesso", "Usuário excluído com sucesso");
          this.loadUsers();
        },
        (error) => {
          this.util.toasterShowError("Atenção", "Erro ao excluir usuário");
        }
      );
    }
  }

  validateForm(): boolean {
    if (!this.user.nome) {
      this.util.toasterShowError("Atenção", "Nome é obrigatório");
      return false;
    }
    if (!this.user.login) {
      this.util.toasterShowError("Atenção", "Login é obrigatório");
      return false;
    }
    if (!this.user.senha && !this.isEditing) {
      this.util.toasterShowError("Atenção", "Senha é obrigatória");
      return false;
    }
    if (!this.user.id_empresa) {
      this.util.toasterShowError("Atenção", "Selecione uma empresa");
      return false;
    }
    return true;
  }

  resetForm() {
    this.user = new User();
    this.isEditing = false;
  }

  goBack() {
    this.router.navigate(['/dashboard']);
  }

  getCompanyName(id: string): string {
    const company = this.companies.find(c => c.id === id);
    return company ? company.nome : '';
  }
}
